
import { Component, Prop, Vue } from 'vue-property-decorator'

/**
 * モーダル要素(vue-js-modalライブラリ)のラッパー
 */
@Component
export default class ModalBase extends Vue {
  /** モーダル表示幅(px) - 必須 */
  @Prop()
  width!: number

  /** モーダル表示高さ(px) - 必須 */
  @Prop()
  height!: number

  /**
   * 背景クリック時にモーダルを閉じるか否か(ライブラリオプション)
   *   未指定時はON=閉じる
   */
  @Prop({ default: true })
  clickToClose!: boolean

  /**
   * モーダルの本体ボックス部分に適用するcssクラス(ライブラリオプション)
   */
  @Prop({ default: '' })
  classes!: string | Array<string>

  /**
   * モーダルをドラッグ可能にするか否か(ライブラリオプション)
   *   未指定時はOFF=位置固定
   *   trueの場合は全範囲ドラッグ可能
   *   文字列(CSSセレクタ)指定時は対象箇所がドラッグ可能に
   */
  @Prop({ default: false })
  draggable!: boolean | string

  /** UUIDから設定される一意な名前 */
  private readonly WINDOW_NAME = this.$getUUID()

  /**
   * モーダルの表示処理
   */
  public show(): void {
    this.$modal.show(this.WINDOW_NAME)
  }

  /**
   * モーダルの消去処理
   */
  public hide(): void {
    this.$modal.hide(this.WINDOW_NAME)
  }

  /**
   * モーダル消去時のイベント通知
   *   ライブラリ独自イベント、上位コンポーネントに対して通知する
   *   閉じた瞬間ではなく、消去が終わったタイミングで発火する
   */
  private closed(): void {
    this.$emit('closed')
  }
}
